import React from 'react'
import successSvg from '../../assets/images/successSvg.svg'

const CreditLimitRequestModal = () => {
    return (
        <>
            <div className="modal fade" id="creditLimitRequestModal" tabindex="-1" role="dialog" aria-labelledby="creditLimitRequestModalLabel">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="success-image">
                                        <img src={successSvg}></img>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="confirm-msg mt-2">
                                        <h6>Success</h6>
                                        <p>Credit limit request send successfully</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="done-btn">
                                        <button type="button" className="btn" data-dismiss="modal">Done</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreditLimitRequestModal